import React, { useState } from "react"
import { Box, Button, Modal, Typography } from "@material-ui/core"
import HappyImg from '../../../assets/images/WarningFirstEmployee/Party Face Emoji.I01.2k.png'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { usageLog } from "../../../store/actions/globalActions";
import CopyImg from '../../../assets/images/WarningFirstEmployee/icone-copiar-colar.png'
import WhatsAppImg from '../../../assets/images/WarningFirstEmployee/icone-whatsapp.png'


export function ModalFirstEmployee() {
    const jwt = require('jsonwebtoken');
    const decodedToken = jwt.decode(localStorage.token);


    const message = `Olá!
 
Temos novidades. Agora, os registros de ponto serão feitos diretamente pelo seu celular. É super fácil e rápido!
Por favor, baixe o app do Puntu agora mesmo usando os links abaixo:
 
Download para Android: https://play.google.com/store/apps/details?id=com.cognusgroup.puntu.app
Download para iPhone: https://apps.apple.com/br/app/puntu/id1365551053?platform=iphone
 
Caso tenha alguma dúvida de como criar sua conta no aplicativo, assista ao vídeo abaixo:
https://youtu.be/NnMUCC2GGns
 
Bom trabalho!`;


    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(message);
            usageLog('firtEmployee/CopyText', decodedToken.companyId, decodedToken.id)
            console.log('Texto copiado para a área de transferência!');
        } catch (err) {
            console.error('Falha ao copiar texto: ', err);
        }
    };
    let url = new URL(window.location.href.toString());
    let type = url.searchParams.get("isFirst");
    let phone = url.searchParams.get("phone");
    const [open, setOpen] = useState(type == 'true' ? true : false)

    const handleClose = () => {
        let url = window.location.href;  // Pega a URL atual
        let urlWithoutParams = url.split('?')[0];  // Remove tudo após o '?'
        window.history.replaceState({}, document.title, urlWithoutParams);
        usageLog('firtEmployee/CloseModal', decodedToken.companyId, decodedToken.id)
        // window.location.reload();
        setOpen(false)
    }

    return (


        <Modal
            open={open}
            // open={true}
            // onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"

        >
            <Box
                sx={styles.Box}
            >

                <img
                    alt="icon"
                    src={HappyImg}
                    style={styles.img}
                />
                <Typography
                    id="modal-modal-description"
                    sx={{ mt: 2 }}
                    textAlign={'center'}
                    style={styles.FirstTypography}>
                    Tudo certo :D <br />
                    Seu 1º funcionário foi cadastrado!
                </Typography>
                <Typography style={styles.SecondTypography}>
                    Peça para seu funcionário baixar o app do Puntu.
                </Typography>
                <Button
                    style={styles.FirstButton}
                    onClick={copyToClipboard}
                >
                    <div></div>
                    COPIAR MENSAGEM
                    <img
                        alt="icon"
                        src={CopyImg}
                        style={styles.SecondImg}
                    />
                </Button>
                <Button
                    style={styles.SecondButton}
                    onClick={() => {
                        let decodedPhone = decodeURIComponent(phone);
                        let whatsappPhone = decodedPhone.replace(/\D/g, '');
                        window.open(`https://wa.me/55${whatsappPhone}?text=${encodeURIComponent(message)}`, '_blank');
                        usageLog('firtEmployee/ButtonWhatsApp', decodedToken.companyId, decodedToken.id);
                        // Limpar os parâmetros da URL

                    }}
                >
                    <div></div>
                    ENVIAR PELO WHATSAPP
                    <img
                        alt="icon"
                        src={WhatsAppImg}
                        style={styles.ThirdImg}
                    />
                </Button>

                <Typography style={styles.ThirdTypography}>
                    Use os botões acima para copiar a mensagem <br />
                    ou enviar o link de download pelo WhatsApp.
                </Typography>
                <Button
                    style={styles.ThirdButton}
                    onClick={handleClose}

                >
                    SAIR
                </Button>
            </Box>
        </Modal>
    )
}

const styles = {
    Box: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        height: 500,
        // bgcolor: 'background.paper',
        // boxShadow: 'none',
        p: 4,
        backgroundColor: '#4851de',
        borderRadius: '20px',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 'none',
        display: 'flex', // Adicione isso
        alignItems: 'center', // Adicione isso
        flexDirection: 'column',
    },
    img: {
        width: '250px',
        height: '250px',
        position: 'absolute',
        top: '-130px',
        left: '50%',
        transform: 'translateX(-50%)'
    },
    FirstTypography: {
        fontFamily: 'Montserrat',
        color: 'white',
        fontSize: '27px',
        textAlign: 'center',
        fontWeight: 'bold',
        marginTop: 70
    },
    SecondTypography: {
        textAlign: 'center',
        fontFamily: 'Montserrat',
        color: 'white',
        fontWeight: 'bold',
        marginTop: 25,
        fontSize: 14
    },
    FirstButton: {
        width: '335px', // Ajuste a largura do botão
        height: 40,
        display: 'flex', // Use flex para alinhar o texto e a imagem
        justifyContent: 'space-between', // Espaço entre o texto e a imagem
        alignItems: 'center', // Alinhe o texto e a imagem verticalmente
        padding: '10px',
        backgroundPosition: 'right', // Posicione a imagem à direita
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'white',
        borderRadius: 15,
        color: '#4851de',
        fontFamily: 'Montserrat',
        fontWeight: 'bold',
        marginTop: 30,
        fontSize: 17
    },
    SecondImg: {
        width: 20,
        height: 20,
        marginLeft: -10
    },
    SecondButton: {
        width: '335px',
        height: 40,
        display: 'flex', // Use flex para alinhar o texto e a imagem
        justifyContent: 'space-between', // Espaço entre o texto e a imagem
        alignItems: 'center', // Alinhe o texto e a imagem verticalmente
        padding: '10px',
        backgroundPosition: 'right', // Posicione a imagem à direita
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#01a000',
        borderRadius: 15,
        color: 'white',
        fontFamily: 'Montserrat',
        fontWeight: 'bold',
        marginTop: 5,
        fontSize: 17
    },
    ThirdImg: {
        width: 25,
        height: 25,
        marginLeft: -10
    },
    ThirdTypography: {
        color: 'white',
        fontSize: 14,
        marginTop: 22,
        textAlign: 'center'
    },
    ThirdButton: {
        color: 'white',  // Cor do texto
        backgroundColor: '#4851de',  // Cor de fundo
        border: '1px solid white',  // Borda
        borderRadius: 20,
        marginTop: 25,
        width: '110px'
    }

}
